import { useSelector } from 'react-redux';
import { RootState } from '../store';

export const usePendingHook = (type: string): boolean => {
    const loaderStateByType = useSelector<RootState, string[] | undefined>(state => state.loader[type]);
    return !!loaderStateByType?.length;
};
